module.exports = __webpack_public_path__ + "img/weddingRingsSecretHeart-Collage@2x.ac8eb5c.webp";